export default __webpack_public_path__ + "static/media/img-ovato-coin-front-new.0848c6f4.png";